<template>
  <ContentSection>
    <div class="relative overflow-hidden">
      <div class="relative mr-[-80%] flex sm:mr-[-60%] lg:mr-[-20%]">
        <Swiper
          v-if="Array.isArray(data.images) && data.images.length > 0"
          :breakpoints="breakpoints"
          class="first:pl-4 sm:first:pl-9 xl:first:pl-28"
          @swiper="onSwiper"
          @slide-change="onSlideChange()"
          @reach-beginning="
            $refs.sliderButtons.reachedBeginningOrEnd('beginning')
          "
          @reach-end="$refs.sliderButtons.reachedBeginningOrEnd('end')"
          @from-edge="$refs.sliderButtons.fromEdge()"
        >
          <SwiperSlide v-for="(image, index) in data.images" :key="image.id">
            <AppImage
              loading="lazy"
              height="100vh"
              :src="image"
              class="select-none rounded-lg object-cover transition-all"
              :class="{
                'mt-[16.5%]':
                  getLayout(image) === 'landscape' && index <= activeIndex + 1,
                'mt-[60%]':
                  getLayout(image) === 'landscape' && index > activeIndex + 1,
                'aspect-[3/2]': getLayout(image) === 'landscape',
                'aspect-[2/3]': getLayout(image) === 'portrait',
              }"
              :aspect-ratio="getLayout(image) === 'landscape' ? 3 / 2 : 2 / 3"
            />
          </SwiperSlide>

          <!-- EMPTY END SLIDE -->
          <SwiperSlide />
        </Swiper>
      </div>

      <!-- ARROWS -->
      <SliderButtons
        ref="sliderButtons"
        class="absolute top-[58%] left-8 z-10 sm:top-[60%] sm:left-16 xl:left-36"
        @prev="swiper.slidePrev()"
        @next="swiper.slideNext()"
      />
    </div>
    <!-- BACKGROUND -->
    <div
      class="absolute inset-x-0 bottom-0 top-[37%] z-0 hidden bg-amber-100 sm:block"
    />
  </ContentSection>
</template>

<script setup>
// Import Swiper Vue.js components
import { Swiper, SwiperSlide } from 'swiper/vue'

// Import Swiper styles
import 'swiper/css'

const props = defineProps({
  data: { type: Object, required: true },
})

let swiper = {}

let activeIndex = ref(0)

const breakpoints = {
  0: {
    slidesPerView: 2,
    spaceBetween: 32,
  },
  768: {
    slidesPerView: 2,
    spaceBetween: 40,
  },
  1024: {
    slidesPerView: 3,
    spaceBetween: 50,
  },
  1280: {
    slidesPerView: 3,
    spaceBetween: 112,
  },
}

const onSwiper = (swiperElement) => {
  swiper = swiperElement
}

const onSlideChange = () => {
  activeIndex.value = swiper.activeIndex
}

function getLayout(image) {
  if (image.width / image.height > 1) {
    return 'landscape'
  } else {
    return 'portrait'
  }
}
</script>
